import { CustomLink } from '../CustomLink/CustomLink';

import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import styles from "./MarketPlaceCard.module.css"
import FleekCoin from "../../asset/icons/fleek-coin-logo.png"
import * as amplitude from '@amplitude/analytics-browser';
import { trackCustomEvent, CUSTOM_EVENTS, ANALYTICS_PROVIDERS } from '../../utils/analyticsService';

export const MarketPlaceCard = (props)=>{
    const { service: {service_name, logo_url }, starts_from, discount_percentage, search_page_banner_url, vendor_web_path } = props.data;
    
    // Handle Chess.com affiliate redirect
    const handleChessComClick = (e) => {
        e.preventDefault();
        
        // Use centralized analytics for Chess.com affiliate click
        trackCustomEvent(CUSTOM_EVENTS.EXTERNAL_LINK_CLICKED, {
            link_name: 'Chess.com Affiliate',
            source: 'marketplace_card',
            component: 'MarketPlaceCard',
            vendor_name: service_name,
            vendor_web_path: vendor_web_path,
            affiliate_url: 'https://chess.com/membership?ref_id=372424947',
            discount_percentage: discount_percentage,
            starts_from: starts_from
        },ANALYTICS_PROVIDERS.AMPLITUDE);
        
        window.open('https://chess.com/membership?ref_id=372424947', '_blank');
    };
    
    // Check if this is Chess.com
    const isChessCom = vendor_web_path === 'chess.com';
    
    if (isChessCom) {
        return(
            <div className={styles.card} onClick={handleChessComClick} style={{ cursor: 'pointer' }}>
                <div className={styles.imageContainer}>
                    <img className={styles.cardImage} src={search_page_banner_url} alt="cardImage" />
                    {discount_percentage ? <div className={styles.cardSubTextContainer}>
                        <p className={styles.cardSubText}>UPTO {discount_percentage}% off</p>
                        <img className={styles.FleekCoin} src={FleekCoin} alt="FleekCoin"/>
                    </div> : ''}
                </div>
                <div className={styles.detailContainer}>
                    <img className={styles.logo} alt="logo" src= {logo_url} />
                    <div className={styles.detail}>
                        <p className={styles.planName}
                            data-tooltip-id={service_name}
                            data-tooltip-content={service_name}
                            data-tooltip-place='bottom'
                        >{service_name}</p>
                        <p className={styles.planPrice}>{starts_from}</p>
                    </div>
                </div>
                <Tooltip id={service_name} />
            </div>
        );
    }
    
    return(
        <CustomLink to={'/brand/'+ vendor_web_path} className={styles.card}>
            <div className={styles.imageContainer}>
                <img className={styles.cardImage} src={search_page_banner_url} alt="cardImage" />
                {discount_percentage ? <div className={styles.cardSubTextContainer}>
                    <p className={styles.cardSubText}>UPTO {discount_percentage}% off</p>
                    <img className={styles.FleekCoin} src={FleekCoin} alt="FleekCoin"/>
                </div> : ''}
            </div>
            <div className={styles.detailContainer}>
                <img className={styles.logo} alt="logo" src= {logo_url} />
                <div className={styles.detail}>
                    <p className={styles.planName}
                        data-tooltip-id={service_name}
                        data-tooltip-content={service_name}
                        data-tooltip-place='bottom'
                    >{service_name}</p>
                    <p className={styles.planPrice}>{starts_from}</p>
                </div>
            </div>
            <Tooltip id={service_name} />
        </CustomLink>
    )
}